import { render, staticRenderFns } from "./PackDetail.vue?vue&type=template&id=1c764eb5&"
import script from "./PackDetail.vue?vue&type=script&lang=js&"
export * from "./PackDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports